import React from 'react';
import { SvgIcon } from '@mui/material';

function ArrowUpIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.83337 11.6667L10 7.5L14.1667 11.6667H5.83337Z" fill="#656985" />
      </svg>
    </SvgIcon>
  );
}

export default ArrowUpIcon;
